import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const ShopHomePage = lazy(() =>
    import('../pages/ShopPage/ShopHomePage').then((module) => ({
        default: module.default,
    }))
)

const MerchandisePage = lazy(() =>
    import('../pages/ShopPage/MerchandisePage').then((module) => ({
        default: module.default,
    }))
)

const CheckoutPage = lazy(() =>
    import('../pages/ShopPage/ShopcartPage').then((module) => ({
        default: module.default,
    }))
)

const ShopTermsPage = lazy(() =>
    import('../pages/ShopPage/ShopTermsPage').then((module) => ({
        default: module.default,
    }))
)

export const shopPaths = {
    checkout: 'check-out',
    policies: 'policies',
} as const

const shopRoutes: RouteObject[] = [
    {
        index: true,
        element: <ShopHomePage />,
        handle: {
            meta: {
                title: 'Spark Shop - Spark Relief Teachers',
                description:
                    'Check out our official Spark Relief Teacher merchandise for your day-to-day casual relief teaching needs!',
            },
        },
    },
    {
        path: ':itemId',
        element: <MerchandisePage />,
    },
    {
        path: shopPaths.checkout,
        element: <CheckoutPage />,
        handle: {
            meta: {
                title: 'Spark Shop - Checkout',
                description:
                    'Check out our official Spark Relief Teacher merchandise for your day-to-day casual relief teaching needs!',
            },
        },
    },
    {
        path: shopPaths.policies,
        element: <ShopTermsPage />,
        handle: {
            meta: {
                title: 'Spark Shop - Policies',
                description:
                    'Check out our official Spark Relief Teacher merchandise for your day-to-day casual relief teaching needs!',
            },
        },
    },
]

export default shopRoutes
